import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreateMovimentacaoPaleteEntradaBody,
  ICreateMovimentacaoPaleteEntradaResponse,
  ICreateMovimentacaoPaleteSaidaBody,
  ICreateMovimentacaoPaleteSaidaResponse,
  IGetMovimentacaoPaleteByIdResponse,
  IGetMovimentacaoPaleteByPlacaCarretaResponse,
  IGetMovimentacoesPaletesPaginatedByFiltersParams,
  IGetMovimentacoesPaletesPaginatedByFiltersResponse
} from './palete.model';

@Injectable({
  providedIn: 'root'
})
export class PaleteService {
  constructor(private http: HttpClient) {}

  public CreateMovimentacaoPaleteEntrada(
    body: ICreateMovimentacaoPaleteEntradaBody,
    guid: string
  ): Observable<ICreateMovimentacaoPaleteEntradaResponse> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });
    const url = `${environment.baseURL}MovimentacaoPalete/CreateMovimentacaoPaleteEntrada`;
    return this.http.post<any>(url, body, { headers: headers });
  }

  public CreateMovimentacaoPaleteSaida(
    body: ICreateMovimentacaoPaleteSaidaBody,
    guid: string
  ): Observable<ICreateMovimentacaoPaleteSaidaResponse> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });
    const url = `${environment.baseURL}MovimentacaoPalete/CreateMovimentacaoPaleteSaida`;
    return this.http.post<any>(url, body, { headers: headers });
  }

  public GetMovimentacoesPaletesPaginatedByFilters(
    params: IGetMovimentacoesPaletesPaginatedByFiltersParams
  ): Observable<IGetMovimentacoesPaletesPaginatedByFiltersResponse> {
    params.PAGE_NUMBER = params.PAGE_NUMBER || 1;
    const invalidParams = ['', null, undefined, NaN, 0];
    const validParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => !invalidParams.includes(value)
      )
    );

    const url = `${environment.baseURL}MovimentacaoPalete/GetMovimentacoesPaletesPaginatedByFilters`;
    return this.http.get<any>(url, { params: validParams });
  }

  public GetReceiptEntradaMovimentacaoPaleteById(
    PK_MOVM_PLTE: number,
    FL_TIPO_DOCU: number
  ): Observable<any> {
    const url = `${environment.baseURL}MovimentacaoPalete/GetReceiptMovimentacaoPaleteById?PK_MOVM_PLTE=${PK_MOVM_PLTE}&FL_TIPO_DOCU=${FL_TIPO_DOCU}`;
    return this.http.get<any>(url);
  }

  public GetReceiptSaidaMovimentacaoPaleteById(
    PK_MOVM_PLTE: number,
    FL_TIPO_DOCU: number
  ): Observable<any> {
    const url = `${environment.baseURL}MovimentacaoPalete/GetReceiptMovimentacaoPaleteById`;
    const params = { PK_MOVM_PLTE, FL_TIPO_DOCU };

    return this.http.get<any>(url, { params });
  }

  public GetMovimentacaoPaleteByPlacaCarreta(
    TX_PLCA_CRRT: string
  ): Observable<IGetMovimentacaoPaleteByPlacaCarretaResponse> {
    const url = `${environment.baseURL}MovimentacaoPalete/GetMovimentacaoPaleteByPlacaCarreta`;
    return this.http.get<any>(url, { params: { TX_PLCA_CRRT } });
  }
  public GetMovimentacaoPaleteById(
    PK_MOVM_PLTE: number
  ): Observable<IGetMovimentacaoPaleteByIdResponse> {
    const url = `${environment.baseURL}MovimentacaoPalete/GetMovimentacaoPaleteById?PK_MOVM_PLTE=${PK_MOVM_PLTE}`;
    return this.http.get<any>(url);
  }
}
